import * as React from 'react'

type Props = {
	condition: boolean;
};

/**
 * Render children only if condition is true
 * @param condition {boolean} - condition to render children
 * @param children {React.ReactNode} - children to render
 * @returns render the children if condition is true, otherwise return null
 * @constructor
 */
export const Conditional: React.FC<Props> = ({ condition, children }) => {
	if (condition) {
		// eslint-disable-next-line react/jsx-no-useless-fragment
		return <>{children}</>;
	}

	return null;
};
